package kz.dentalcrm.app.data.network.request_model

import kotlinx.serialization.Serializable

@Serializable
data class AppointmentService(
    val discount: Int,
    val id: Int,
    val overallPrice: Int,
    val price: Int,
    val quantity: Int,
    val service: Service
)